import { useEffect, useState } from 'react';
const Plan = () => {
  const [offer, setOffers] = useState([]);
  useEffect(() => {
    fetch('/data/offer.json')
      .then((res) => res.json())
      .then(setOffers)
      .catch(console.error);
  }, []);
  const trainig = offer?.data?.find((o) => o.name === 'PLAN TRENINGOWY');
  return (
    <div class="max-w-3xl mx-auto space-y-6 mb-6">
      <h1 class="text-4xl font-bold text-center mb-4 mt-4">PLAN TRENINGOWY</h1>
      <h3 class="text-1xl text-center mb-8 mt-4 text-gray-300">
        W pełni spersonalizowany plan treningowy i dietetyczny, dopasowany do
        Twoich celów i dostępnych zasobów. Współpraca online to doskonała opcja,
        jeśli chcesz trenować w komfortowych warunkach, ale bez utraty
        efektywności.
      </h3>
      <div class="grid grid-cols-1 gap-6 ">
        {' '}
        {trainig?.offers?.map((i, index) => (
          <div key={index} class="bg-gray-800 p-6 rounded-2xl shadow-lg">
            <div>
              <h2 class="text-2xl font-semibold mb-2">{i.name}</h2>
              <p class="text-lg font-bold">{i.price} zł</p>
            </div>
          </div>
        ))}
        {/* <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">1 miesiąc</h2>
          <p class="text-lg font-bold">150 zł</p>
        </div> */}
      </div>
    </div>
  );
};

export default Plan;
